import { IFooter } from '../models/footer.models';
import { ActionReducer, createFeatureSelector, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import { FooterActions } from '../actions';

export interface FooterState {
  socialMediaFooter: IFooter | null;
  socialMediaFooterError: string | null;
  footerNavigation: IFooter | null;
  footerNavigationError: string | null;
}

export const initialState: FooterState = {
  socialMediaFooter: null,
  socialMediaFooterError: null,
  footerNavigation: null,
  footerNavigationError: null,
};

export const footerState: MemoizedSelector<object, FooterState> = createFeatureSelector<FooterState>('footer');

export const selectSocialMediaFooter: MemoizedSelector<object, IFooter | null> = createSelector(
  footerState,
  (state: FooterState) => state.socialMediaFooter,
);

export const selectFooterNavigation: MemoizedSelector<object, IFooter | null> = createSelector(
  footerState,
  (state: FooterState) => state?.footerNavigation,
);

export const FooterReducer: ActionReducer<FooterState> = createReducer(
  initialState,
  on(FooterActions.loadFooterNavigation, (state: FooterState) => {
    return {
      ...state,
      footerNavigation: null,
    };
  }),
  on(FooterActions.loadFooterNavigationSuccess, (state: FooterState, action) => {
    return {
      ...state,
      footerNavigation: action.footerNavigation,
    };
  }),
  on(FooterActions.loadFooterNavigationFail, (state: FooterState, action) => {
    return {
      ...state,
      footerNavigationError: action.resError,
    };
  }),
  on(FooterActions.loadSocialMediaFooter, (state: FooterState) => {
    return {
      ...state,
      socialMediaFooter: null,
    };
  }),
  on(FooterActions.loadSocialMediaFooterSuccess, (state: FooterState, action) => {
    return {
      ...state,
      socialMediaFooter: action.socialMediaFooter,
    };
  }),
  on(FooterActions.loadSocialMediaFooterFail, (state: FooterState, action) => {
    return {
      ...state,
      socialMediaFooterError: action.resError,
    };
  }),
);
